// extracted by mini-css-extract-plugin
export default {"title":"SolutionEffect_title__OpZwx","expertMode":"SolutionEffect_expertMode__HrPSv"};